import axios from 'axios';
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";
import { api_url } from "@/config/api_url";



export const useCsvStore = defineStore('csvStore',{
    state:() => ({
        csvs:{},
        loading:false
    }),
    actions:{
        async fetchFiles(){
            this.loading = true;
            axios.defaults.headers.common = {
                Authorization: `${localStorage.getItem('token')}`
            };
            try {
                const result = await axios.get(`${api_url}/admin/csv-files/getFiles`);
                this.csvs = result.data;
                this.loading = false;
            } catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        
        },

        async deleteFile(path,file){
            this.loading = true;
            axios.defaults.headers.common = {
                Authorization: `${localStorage.getItem('token')}`
            };
            try {
                const result = await axios.delete(`${api_url}/admin/csv-files/${path}/${file}`);
                this.csvs = result.data;
                useNotificationStore().setNotification("CSV File Deleted",file + " file was deleted", 'mdi-alert', 'success');
            } catch (error) {
                this.handleError(error.response.data);
            }finally{
                this.loading = false;
            }
        },

        handleError(error) {
            useNotificationStore().setNotification('Error', error.message, 'mdi-alert', 'error');
        },
    }

});